'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _hasMany = require('../helpers/hasMany');
var _ContentTypes = require('../constants/ContentTypes');
var contentTypes = _interopRequireWildcard(_ContentTypes);
var _StaticContent = require('../components/StaticContent');
var _StaticContent2 = _interopRequireDefault(_StaticContent);
var _site = require('../actions/site');
var _pages = require('../helpers/pages');
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var assignProperty = function assignProperty(result, prop) {
  result[prop.propertyName] = prop.value;
  return result;
};
var parseProperties = function parseProperties(properties) {
  return {
    cssProperties: Object.keys(properties).map(function (k) {
      return properties[k];
    }).filter(function (obj) {
      return obj.type === 'css';
    }).reduce(assignProperty, {}),
    otherProperties: Object.keys(properties).map(function (k) {
      return properties[k];
    }).filter(function (obj) {
      return obj.type !== 'css';
    }).reduce(assignProperty, {})
  };
};
var Content = function (_Component) {
  _inherits(Content, _Component);
  function Content() {
    _classCallCheck(this, Content);
    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
  }
  _createClass(Content, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        contentId = _props.contentId,
        content = _props.content,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        entities = _props.entities,
        pagination = _props.pagination,
        editable = _props.editable,
        preview = _props.preview,
        connectDragPreview = _props.connectDragPreview,
        isEditing = _props.isEditing,
        setActiveContent = _props.setActiveContent,
        setCurrentPage = _props.setCurrentPage,
        onChangeText = _props.onChangeText,
        responsiveMode = _props.responsiveMode,
        fetchPage = _props.fetchPage,
        pages = _props.pages,
        currentPageId = _props.currentPageId,
        ContentClass = _props.ContentClass,
        highlight = _props.highlight,
        wrapWithDropZone = _props.wrapWithDropZone,
        otherData = _props.otherData;
      var type = content.type,
        value = content.value,
        childContents = content.childContents,
        parentId = content.parentId;
      var children = childContents && childContents.map(function (childId, childIndex) {
        return _react2.default.createElement(ContentClass, {
          ContentClass: ContentClass,
          key: childId,
          contentId: childId,
          contentIndex: childIndex,
          editable: editable,
          fetchPage: fetchPage
        });
      });
      var childProps = {
        type: type,
        value: value,
        contentId: contentId,
        parentId: parentId,
        cssProperties: cssProperties,
        otherProperties: otherProperties,
        responsiveMode: responsiveMode,
        editable: editable,
        preview: preview,
        isEditing: isEditing,
        children: children,
        setActiveContent: setActiveContent,
        setCurrentPage: setCurrentPage,
        highlight: highlight,
        connectDragPreview: connectDragPreview,
        entities: entities,
        pagination: pagination,
        fetchPage: fetchPage,
        wrapWithDropZone: wrapWithDropZone,
        onChangeText: onChangeText,
        pages: pages,
        otherData: otherData,
        currentPageId: currentPageId
      };
      return _react2.default.createElement(_StaticContent2.default, childProps);
    }
  }]);
  return Content;
}(_react.Component);
Content.propTypes = {
  contentId: _propTypes2.default.string.isRequired,
  editable: _propTypes2.default.bool,
  content: _propTypes2.default.object,
  properties: _propTypes2.default.object
};
var getEntitiesAndPagination = function getEntitiesAndPagination(site, contentType) {
  var entityKey = contentTypes.entityKeys[contentType];
  if (!!entityKey) {
    var entities = null;
    var pagination = null;
    if (Array.isArray(entityKey)) {
      entities = entityKey.reduce(function (result, entityName) {
        result[entityName] = site.entities[entityName];
        return result;
      }, {});
      pagination = site.pagination[entityKey[0]];
    } else {
      entities = site.entities[entityKey];
      pagination = site.pagination[entityKey];
    }
    return {
      entities: entities,
      pagination: pagination
    };
  }
  return null;
};
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var app = _ref.app,
    site = _ref.site,
    pages = _ref.pages,
    pageOrder = _ref.pageOrder,
    contents = _ref.contents,
    properties = _ref.properties,
    otherData = _ref.otherData;
  var contentId = _ref2.contentId,
    content = _ref2.content;
  return _extends({
    content: content || contents[contentId]
  }, parseProperties(_extends({}, (0, _hasMany.normalizedWhere)(properties, 'parentId', contentId), app && (0, _hasMany.normalizedWhere)(app.modifiedItems.properties, 'parentId', contentId))), {
    responsiveMode: site.responsiveMode
  }, getEntitiesAndPagination(site, contents[contentId].type), {
    pages: (0, _pages.orderPages)(pages, pageOrder),
    currentPageId: site.currentPageId,
    otherData: otherData
  });
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var contentId = _ref3.contentId,
    blockId = _ref3.blockId,
    isRootContent = _ref3.isRootContent;
  return {
    setCurrentPage: function setCurrentPage(id) {
      dispatch((0, _site.setCurrentPage)(id));
    }
  };
};
var comparableProperties = ['entities', 'pagination', 'content', 'cssProperties', 'otherProperties', 'isEditing', 'responsiveMode', 'pages', 'currentPageId', 'contentIndex', 'canPaste'];
var arePropsEqual = function arePropsEqual(next, prev) {
  return comparableProperties.every(function (propName) {
    return _lodash2.default.isEqual(next[propName], prev[propName]);
  });
};
var areStatePropsEqual = arePropsEqual;
var areOwnPropsEqual = arePropsEqual;
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, {
  areStatePropsEqual: areStatePropsEqual,
  areOwnPropsEqual: areOwnPropsEqual
})(Content);